import { render, staticRenderFns } from "./OnboardUserList.vue?vue&type=template&id=1ba490e6&scoped=true&"
import script from "./OnboardUserList.vue?vue&type=script&lang=ts&"
export * from "./OnboardUserList.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardUserList.vue?vue&type=style&index=0&id=1ba490e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba490e6",
  null
  
)

export default component.exports